import * as React from 'react';
import { FilterValue } from '../../api';
import { IListFilterProps } from './props';

interface ISearchFilterProps<T = any> extends IListFilterProps<T> {
  value?: FilterValue;
}

const SearchFilter: React.FunctionComponent<ISearchFilterProps> = (props) => {
  const [search, setSearch] = React.useState(props.value?.value);

  const onClose = () => {
    setSearch('');
    props.onClose?.();
  };

  React.useEffect(() => {
    setSearch(props.value?.value);
  }, [props.value]);

  const onApply = () => {
    setSearch('');
    props.applyFilter?.({ label: search, value: search });
  };

  return (
    <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100  bg-white zIndex-1">
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 text-white mb-3">
        <h6 className="m-0 font-xs font-weight-semibold">{props.label}</h6>
        <span
          className="cursor-pointer d-inline-block text-center rounded-circle sub-dropdown-back ml-3"
          onClick={onClose}
        >
          <i className="icon-close font-xxs"></i>
        </span>
      </div>
      <div className="custom-dropdown__search border bg-gray-100 d-flex mb-2 position-sticky top-0 zIndex-1">
        <input
          type="text"
          className="form-control bg-transparent border-0 py-0 px-1 font-weight-semibold font-normal"
          placeholder={`Search ${props.label}`}
          onChange={(e) => setSearch(e.target.value)}
          ref={(input) => input && input.focus()}
          value={search}
        />
      </div>
      <div className="px-3 text-right">
        <button
          type="button"
          className="btn btn-primary py-2 px-4 font-weight-semibold"
          onClick={onApply}
        >
          <span className="px-2">Apply</span>
        </button>
      </div>
    </div>
  );
};

export default SearchFilter;
